import { DeviceUsageType } from "src/app/features/tests/features/constants";

export const DEVICE_USAGE_CONFIG = {
  [DeviceUsageType.IN_LAB]: {
    label: 'In Lab',
    class: 'in-lab',
  },
  [DeviceUsageType.HOME]: {
    label: 'HST',
    class: 'home',
  },
};
